<template>
    <h5 v-if="TamanhoFonteLabel == 'H5'">
               {{NomeLabel}}
      <div  v-if="habilitarClick" class="label__field">

        <div @click="abrirDisclaimer" style="width: 100%; height: 100%; padding: 5px; padding-left: 0px; justify-content: flex-start; align-items: center; gap: 5px; display: inline-flex">
            <div style="color: #00235C; font-size: 12px; font-family: Inter; font-weight: 400; text-decoration: underline; word-wrap: break-word">saiba mais</div>
            <img style="width: 18px; height: 18px; cursor: pointer;transform: rotate(5deg);" src="@/assets/info.png" />
        </div>

      </div>

    </h5>

    <h3 v-if="TamanhoFonteLabel == 'H3'">

       {{NomeLabel}}
      <div  v-if="habilitarClick" class="label__field">

        <div @click="abrirDisclaimer" style="width: 100%; height: 100%; padding: 5px; padding-left: 0px; justify-content: flex-start; align-items: center; gap: 5px; display: inline-flex">
            <div style="color: #00235C; font-size: 12px; font-family: Inter; font-weight: 400; text-decoration: underline; word-wrap: break-word">saiba mais</div>
            <img style="width: 18px; height: 18px; cursor: pointer;transform: rotate(5deg);" src="@/assets/info.png" />
        </div>

      </div>
    </h3>


    <ModalInformativoDisclaimerVue />

</template>

<script>
import { mapGetters } from "vuex";

import ModalInformativoDisclaimerVue from './ModalInformativoDisclaimer.vue'

export default {
    computed: {
        ...mapGetters({
            listaDisclaimer: "GET_LISTA_DISCLAIMER",
        }),
    },
    name: "LabelDisclaimer",
    props: ["TamanhoFonteLabel","NomeLabel", "TipoCliente", "Sessao", "SubSessao"],
    components: {ModalInformativoDisclaimerVue},
    data(){
        return {
            habilitarClick: false
        }
    },
    created(){
        var objDisclaimer = { Sessao: this.Sessao, SubSessao: this.SubSessao, TipoCliente: this.TipoCliente, Abrir: false};
        this.$store.commit('SET_MODAL_DISCLAIMER_INFORMATIVO', objDisclaimer);

          if(this.listaDisclaimer.find(disclaimer => disclaimer.TipoCliente == objDisclaimer.TipoCliente && disclaimer.Secao == objDisclaimer.Sessao && disclaimer.SubSecao == objDisclaimer.SubSessao) != null){
                this.habilitarClick = true;
          }else{
                this.habilitarClick = false;
          }

    },
    methods: {
        abrirDisclaimer(){
            var objDisclaimer = { Sessao: this.Sessao, SubSessao: this.SubSessao, TipoCliente: this.TipoCliente, Abrir: true};
            this.$store.commit('SET_MODAL_DISCLAIMER_INFORMATIVO', objDisclaimer);
        }
    },
    watch: {
        objDisclaimer(){
          if(this.listaDisclaimer.find(disclaimer => disclaimer.TipoCliente == this.objDisclaimer.TipoCliente && disclaimer.Secao == this.objDisclaimer.Sessao && disclaimer.SubSecao == this.objDisclaimer.SubSessao) != null){
                this.habilitarClick = true;
          }else{
                this.habilitarClick = false;
          }
        }
    }
}
</script>

<style lang="scss" scoped>
    .label__field
    {
        padding-right: 10px;
    }
    
    h5
    {
        margin-top: 0px;
        font-family: 'Inter', sans-serif; /* Fonte Inter */
    }

    
    h3{
        margin-left: 20px;
        color: #101828;
        font-weight: 500;
        font-family: 'Inter', sans-serif;
    }
</style>
